export function DisclaimerBlock() {
  return (
    <aside
      className="relative bg-panel border border-hairline rounded-md p-5 max-w-3xl overflow-hidden"
      aria-label="Indication disclaimer"
    >
      <div
        aria-hidden="true"
        className="absolute left-0 top-0 bottom-0 w-[3px] bg-gradient-primary"
      />
      <p className="font-mono text-[10px] uppercase tracking-[0.125em] text-ink-subtle">
        &gt; DISCLAIMER
      </p>
      <p className="mt-2 text-[0.8125rem] leading-relaxed text-ink-muted">
        This is an indication, not a bindable quote. Final premiums are subject to underwriting
        review. Rate tables are estimates and do not guarantee market availability. A Zachary
        broker will reach out to review the formal submission with you.
      </p>
    </aside>
  );
}
